/**
 * @generated SignedSource<<6b42cd5cfebc9f3fa27f75ceabf70ea6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useSafeUserReviews_userProfile$data = {
  readonly reviews: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly author: {
          readonly avatarImage: {
            readonly id: string;
            readonly uid: string;
            readonly url: string;
          } | null;
        };
        readonly commentOnlyVisibleToRecipient: boolean;
        readonly id: string;
        readonly isPositiveReview: boolean;
        readonly onlyVisibleToRecipient: boolean;
        readonly rating: number;
      };
    }>;
  };
  readonly " $fragmentType": "useSafeUserReviews_userProfile";
};
export type useSafeUserReviews_userProfile$key = {
  readonly " $data"?: useSafeUserReviews_userProfile$data;
  readonly " $fragmentSpreads": FragmentRefs<"useSafeUserReviews_userProfile">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useSafeUserReviews_userProfile",
  "selections": [
    {
      "alias": "reviews",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "isPositiveReview": true,
            "onlyVisibleToRecipient": false
          }
        }
      ],
      "concreteType": "UserReviewConnection",
      "kind": "LinkedField",
      "name": "userReviews",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UserReviewEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "UserReview",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "commentOnlyVisibleToRecipient",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "onlyVisibleToRecipient",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isPositiveReview",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "rating",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "UserProfile",
                  "kind": "LinkedField",
                  "name": "author",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ContraImage",
                      "kind": "LinkedField",
                      "name": "avatarImage",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "uid",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "url",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "userReviews(filter:{\"isPositiveReview\":true,\"onlyVisibleToRecipient\":false})"
    }
  ],
  "type": "UserProfile",
  "abstractKey": null
};
})();

(node as any).hash = "a994a2fb469cb8b4c310157853b1b392";

export default node;
